import { LocationDescriptor } from "history";
import { useMemo } from "react";
import { ContractUrls, useContractUrls } from "./contract/routing/ContractUrls";
import { ContractPath } from "./contract/routing/ContractPath";

export type LinkTo =
  | ((urls: ContractUrls) => LocationDescriptor)
  | ContractPath;

export function useLink(to: LinkTo) {
  const urls = useContractUrls();
  const linkTo = useMemo(() => {
    return typeof to === "function" ? to(urls) : urls[to];
  }, [to, urls]);
  return linkTo;
}
